// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-btn-group-container{
    display: flex;
    gap: 0.5em; 
    align-items: end;
  }
  
  .date-picker-container {
    display: flex;
    gap: 0.5em; 
  }
  
  .active {
    filter: invert(100%);
  }
  
  .dashboard-names-create-container {
    display: flex;
    gap: 0.5em;
    align-items: end;
  }`, "",{"version":3,"sources":["webpack://./src/components/date-range/dateRange.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB","sourcesContent":[".date-btn-group-container{\n    display: flex;\n    gap: 0.5em; \n    align-items: end;\n  }\n  \n  .date-picker-container {\n    display: flex;\n    gap: 0.5em; \n  }\n  \n  .active {\n    filter: invert(100%);\n  }\n  \n  .dashboard-names-create-container {\n    display: flex;\n    gap: 0.5em;\n    align-items: end;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
